import React, { useEffect } from 'react';
import { initPixel, trackPageView } from './lib/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Included } from './components/Included';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Benefits } from './components/Benefits';
import { Audience } from './components/Audience';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initPixel('1329604392388692');
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-legal-900 text-slate-50 font-sans selection:bg-gold-500/30" data-id="element-0" data-mp="23t8gmcjw0fce">
      <main data-id="element-1" data-mp="3ihv0i9zd8dgr">
        <Hero data-id="element-2" data-mp="3mlja0y7k5j4n" />
        <StatsBar data-id="element-3" data-mp="3mlaxj7fckftz" />
        <Problem data-id="element-4" data-mp="3mkrgdsxitvh0" />
        <Solution data-id="element-5" data-mp="3mk83iqmq9x9u" />
        <Included data-id="element-6" data-mp="3mjpyp5m02aqb" />
        <Modules data-id="element-7" data-mp="3rc9em985thya" />
        <Bonuses data-id="element-8" data-mp="3rbr9en3irte8" />
        <Benefits data-id="element-9" data-mp="3rdaqgfx028h2" />
        <Audience data-id="element-10" data-mp="3rcsy3udgkeef" />
        <Testimonials data-id="element-11" data-mp="3recdzjv7cnfo" />
        <Guarantee data-id="element-12" data-mp="5yhgo69t1c8" />
        <Offer data-id="element-13" data-mp="6htjo98ovic" />
        <FAQ data-id="element-14" data-mp="4ww9qvjiygs" />
        <FinalCTA data-id="element-15" data-mp="5gfdawxfswe" />
      </main>
      <Footer data-id="element-16" data-mp="7stfczkdj46" />
    </div>;
}